<section>
  <div class="row mx-0" [hidden]="!isFormView">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-register-invoice-detail [invoiceModel]="invoiceModel" [invoiceDetailContract]="invoiceDetail"
        [defaultStoreIdForBranch]="defaultStoreIdForBranch" (updateListDetail)="getUpdateListDetail()"
        (invoiceContract)="getInvoice($event)" (isFormView)="getFormView($event)"></app-register-invoice-detail>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
    <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
      [showCheckbox]="!disabledButton" [checkBoxAction]="checkboxActions"
      [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getDetailsInvoiceWithPagination()"
      (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
    </app-custom-table>
  </div>

</section>